import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class StandLayoutModel extends ApiModel {
  static get path() {
    return '/backend/stand_layouts/{?id}';
  }

  @computed
  public get description(): string {
    return this.get('description', '');
  }

  @computed
  public get layoutTypeId(): string {
    return this.get('layoutType.id', '');
  }

  @computed
  public get layoutTypeIri(): string {
    return this.get('layoutType.@id', '');
  }

  @computed
  public get standId(): string {
    return this.get('stand.id', '');
  }

  @computed
  public get standIri(): string {
    return this.get('stand.@id', '');
  }
}
